import { postJson } from "@/domain/common/client/ApiClient"
import {
  ExcelExportRequestPayload,
  ExcelExportResponsePayload,
} from "@bracket/idl/main/excel/payload/ExcelPayloadPt"
import type { ExcelKindPayload } from "@bracket/idl/main/excel/payload/ExcelPayloadPt"
import type { ExportedExcel } from "@/domain/excel/model/Excel"

/**
 * 엑셀 출력 클라이언트 (관리자).
 *
 * **한 번 부르면 파일이 온다** — 서버가 메모리에서 만들어 응답 본문(`content`)에 싣는다.
 * 서버에 파일이 남지 않으므로 상태 조회 · 다운로드 경로가 없다.
 */
const ExcelClient = {
  async export(
    kind: ExcelKindPayload,
    tournamentId: string,
  ): Promise<ExportedExcel> {
    const request = ExcelExportRequestPayload.create({ kind, tournamentId })

    const json = await postJson<unknown>(
      "/bo/excel/export",
      ExcelExportRequestPayload.toJSON(request),
    )
    const response = ExcelExportResponsePayload.fromJSON(json)

    return { fileName: response.fileName, content: response.content }
  },
}

export { ExcelClient }
